import { MonthlyExpenseSummary } from "../models/MonthlyExpenseSummary";
import { Comment } from "../models/Comment";
import api from "./api"; // custom axios instance

export const MonthlyExpenseSummaryService = {
  async getMonthlyExpenseSummarys(
    matterId: string,
  ): Promise<MonthlyExpenseSummary[]> {
    const res = await api.get(`/api/v1/monthly-expense-summaries`, {
      params: { matterId },
    });
    return res.data?.data ?? [];
  },

  async createMonthlyExpenseSummary(
    monthlyExpenseSummary: Partial<MonthlyExpenseSummary>,
  ): Promise<string> {
    const res = await api.post(
      "/api/v1/monthly-expense-summaries",
      monthlyExpenseSummary,
    );
    return res.data?.data?._id;
  },

  async updateMonthlyExpenseSummary(
    monthlyExpenseSummaryId: string,
    monthlyExpenseSummaryData: Partial<Omit<MonthlyExpenseSummary, "_id">>,
  ): Promise<void> {
    await api.patch(
      `/api/v1/monthly-expense-summaries/${monthlyExpenseSummaryId}`,
      monthlyExpenseSummaryData,
    );
  },

  async deleteMonthlyExpenseSummary(
    matterId: string,
    monthlyExpenseSummaryId: string,
  ): Promise<void> {
    await api.delete(
      `/api/v1/monthly-expense-summaries/${monthlyExpenseSummaryId}`,
      {
        params: { matterId },
      },
    );
  },

  async getComments(monthlyExpenseSummaryId: string): Promise<Comment[]> {
    const res = await api.get(
      `/api/v1/monthly-expense-summaries/${monthlyExpenseSummaryId}/comments`,
    );
    return res.data?.data ?? [];
  },
};
